import React from "react";

import MultipleSelectionAttributeCard from "./Components/MultipleSelectionAttributeCard";

import { type AppUserSession } from "@/schemas/auth/session";
import {
  Seeking,
  UserSeekingAttributeSet,
} from "@/schemas/profile/attributes/UserSeekingAttributeSet";
import type { AttributeValue } from "@/schemas/attribute/AttributeSet";

type SeekingProps = {
  session: AppUserSession;
  values: Seeking[];
};

function SeekingSelection({
  session,
  values,
}: SeekingProps): React.JSX.Element {
  const items = values.map((id) => UserSeekingAttributeSet.map[id]);
  const typedValues = items.filter(
    (item): item is AttributeValue => item !== undefined,
  );

  return (
    <MultipleSelectionAttributeCard
      session={session}
      title={"Seeking"}
      icon={"search"}
      attribute={UserSeekingAttributeSet}
      values={typedValues}
    />
  );
}

export default SeekingSelection;
